// extracted by css-extract-rspack-plugin
export default {"root":"root-1X_5f","center":"center-169DG"};